module.exports = __webpack_public_path__ + "static/media/features_bag.3de1a6d0.svg";